
import { Component } from 'vue-property-decorator'
import BaseInput from './BaseInput.vue'

@Component
export default class BasePassword extends BaseInput {
  showPassword = false

  get passwordFieldType(): string {
    return this.showPassword ? 'text' : 'password'
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword
  }
}
